// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__U6cJ3","search":"SearchBar_search__x2YoB","searchButton":"SearchBar_searchButton__16CxT","buscar":"SearchBar_buscar__3uHSO"};